import React from 'react'
import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
} from '@material-ui/core'
import classnames from 'classnames'
import useStyles from './styles'

export interface ButtonProps extends MuiButtonProps {
  component?: React.ComponentType
}

export default function Button({ classes, ...rest }: ButtonProps) {
  const babyUIClasses = useStyles()
  const { root, text, ...remainingClasses } = classes || {}

  return (
    <MuiButton
      classes={{
        root: classnames(root, babyUIClasses.root),
        text: classnames(text, babyUIClasses.text),
        ...remainingClasses,
      }}
      {...rest}
    />
  )
}
